var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendToBlacklist(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 42,
    viewBox: "0 0 180 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.699 35.7845H141.099V36.3845V41.4H12.1757L0.6 29.7526V0.6H167.824L179.4 12.2474V41.4H164.303L160.697 36.0492L160.518 35.7845H160.199H141.699Z",
    fill: "url(#paint0_radial_13295_11123)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.699 35.7845H141.099V36.3845V41.4H12.1757L0.6 29.7526V0.6H167.824L179.4 12.2474V41.4H164.303L160.697 36.0492L160.518 35.7845H160.199H141.699Z",
    fill: "url(#paint1_radial_13295_11123)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.699 35.7845H141.099V36.3845V41.4H12.1757L0.6 29.7526V0.6H167.824L179.4 12.2474V41.4H164.303L160.697 36.0492L160.518 35.7845H160.199H141.699Z",
    stroke: "url(#paint2_linear_13295_11123)",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.241 39.4319L147.164 40.9431L149.117 39.9419V41.7344H150.079V38.7344L147.164 40.2344L144.241 38.7344V39.4319Z",
    fill: "#094043"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150.419 41.6931V41.7344H154.303V41.2319H151.388L150.419 41.6931ZM150.419 38.7344L151.388 39.2369H154.303V38.7344H150.419ZM150.419 39.9869V40.4856H151.388H154.303V39.9869H151.388H150.419Z",
    fill: "#094043"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155.052 38.7344V39.2369V41.7344H156.029V39.2369H157.967V38.7344H155.052Z",
    fill: "#094043"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M158.959 40.7369L159.819 39.8556L160.672 40.7369H161.765L159.819 38.7344L156.904 41.7344H157.983L158.478 41.2319L158.959 40.7369ZM162.246 41.2356H161.167L161.648 41.7344H162.734L162.246 41.2356Z",
    fill: "#094043"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_13295_11123",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.175 1.4898) rotate(90) scale(21.7641 370.186)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#356669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272421",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_13295_11123",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.3081 41.8571) rotate(-90) scale(19.5101 161.513)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F9D9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272421",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13295_11123",
    x1: 89.9999,
    y1: 41.9998,
    x2: 89.9999,
    y2: 0.0000300406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010202"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendToBlacklist);
export default __webpack_public_path__ + "static/media/send_to_blacklist.0371072c1fb3154c5848deee9ac865c6.svg";
export { ForwardRef as ReactComponent };